<template>
  <el-dialog title="学生评定列表上传" width="750px" :visible="bulkImportDialogShow" @open="dialogOpen" @close="dialogClose"
    :close-on-click-modal="false">
    <div class="quality-report-upload">
      <!-- 上传模块 -->
      <div class="upload-module">
        <div class="module-title">上传XLSX表格</div>
        <el-upload ref="upload" :on-change="onChange" class="upload-demo" drag :show-file-list="true"
          action="https://jsonplaceholder.typicode.com/posts/" multiple :auto-upload="false" accept=".xls,.xlsx">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        </el-upload>
      </div>
      <!-- 预览模块 -->
      <div class="preview-module" v-if="tableHtmlShow">
        <div class="module-title">问题列表</div>
        <div class="preview-table" v-html="tableHtml">
          <!-- <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%; max-height: 300px; overflow-y: auto"
            :data="tableData">
            <el-table-column label="#" type="index"> </el-table-column>
            <el-table-column prop="studentName" label="姓名"> </el-table-column>
            <el-table-column prop="studentNumber" label="学号"> </el-table-column>
            <el-table-column prop="studentNumber" label="班级职务"> </el-table-column>
            <el-table-column prop="studentNumber" label="政治面貌"> </el-table-column>
            <el-table-column prop="studentNumber" label="德育评定"> </el-table-column>
            <el-table-column prop="studentNumber" label="评语"> </el-table-column>
          </el-table> -->
        </div>
      </div>
      <!-- 确认上传到服务器 -->
      <div class="confirm-module">
        <el-button type="primary" :loading="submitButtonLoading" @click="upload">{{
          submitButtonLoading ? "上传中" : "确认上传"
        }}</el-button>
        <!-- 下载模版 -->
        <el-button type="success" @click="bulkExport">
          下载模版
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import * as XLSX from "xlsx";
import axios from "axios";
import { baseURL } from "@/api/request";
export default {
  props: ['bulkImportDialogShow', 'className'],
  data() {
    return {
      submitButtonLoading: false,
      // tableData: [],
      tableHtmlShow: false,
      tableHtml: "",
      formData: "", // 上传参数
      file: "", // 文件
    };
  },
  created() {

  },
  methods: {
    // 下载模版点击
    bulkExport() {
      let action = `${baseURL}${this.$url.downloadStudentEvaluate}?gradeId=${this.className[0].gradeId}&classId=${this.className[1].classId}`;
      this.$downloadFile(action);
    },
    // 打开弹出窗口
    dialogOpen() {
      this.tableHtmlShow = false;
      this.tableHtml = '';
      this.formData = '';
      this.file = '';
      // this.$refs.upload.clearFiles();
    },
    // 关闭弹出窗口
    dialogClose() {
      this.tableHtmlShow = false;
      this.tableHtml = '';
      this.formData = '';
      this.file = '';
      this.$refs.upload.clearFiles();
      this.$emit("update:bulkImportDialogShow", false);
    },
    onChange(file, fileList) {
      // console.log(file);
      // console.log(fileList);
      let file_type = file.name.split(".")[1];
      if (!/^(xls|xlsx)$/g.test(file_type)) {
        return this.$message.error("只能选择xlsx或xls类型文件");
      } else {
        //是xlsx，xls文件,读取文件数据
        this.$message.success("上传表格成功");
        this.file = file.raw;
        //是xlsx，xls文件,读取文件数据
        this.readFileData(file.raw, (workbook) => {
          this.readWorkbook(workbook);
        });
      }
    },
    readFileData(file) {
      const fileReader = new FileReader();
      // console.log(fileReader);
      // console.log("XLSX==>", XLSX);
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: "binary",
          });
          const wsname = workbook.SheetNames[0]; // 取第一张表
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); // 生成json表格内容
          // console.log(ws);
          // this.achievementPreviewTableInit(ws);
        } catch (e) {
          console.log("生成表格报错==>", e);
          return false;
        }
      };
      fileReader.readAsBinaryString(file);
    },
    upload() {
      if (this.file == "") {
        return this.$message.error("请添加数据");
      }
      if (this.submitButtonLoading) {
        return this.$message("录入中，请勿重复点击");
      }
      this.submitButtonLoading = true;
      this.formData = new FormData();
      this.formData.append("file", this.file);
      this.formData.append("schoolYear", this.school.schoolYear);
      this.formData.append("semester", this.school.semester);

      let config = {
        headers: {
          bbfAdminTeacherToken: window.localStorage.getItem(
            "bbfAdminTeacherToken"
          ),
          "Content-Type": "multipart/form-data",
        },
      };
      let action = `${baseURL}${this.$url.importStudentEvaluate}`;
      axios
        .post(action, this.formData, config)
        .then((res) => {
          // res.data 服务器返回的数据
          let data = res.data;
          // console.log(data);
          if (res.status != 200) {
            this.$message.error("录入失败");
          } else {
            if (data.code == 200) {
              this.$message.success("录入成功");
              // this.$emit("uploadQualityReportSuccess");
              this.dialogClose();
            } else if (data.code == 401 || data.code == 403) {
              // token失效
              this.$message.error("获取用户信息失败，请重新登录");
              this.$store.dispatch("user/resetToken");
              this.$router.replace({
                path: "login",
                query: { redirect: this.$router.currentRoute.fullPath },
              });
            } else {
              this.$message.error("录入失败");
              this.tableHtml = data.msg;
              this.tableHtmlShow = true;
              // this.$message({
              //   showClose: true,
              //   type: 'error',
              //   dangerouslyUseHTMLString: true,
              //   message: data.msg
              // });
            }
          }
          this.submitButtonLoading = false;
        })
        .catch((err) => {
          this.submitButtonLoading = false;
          this.$message.error("录入失败，请稍后再试");
        });
    }
  },
};
</script>

<style scoped lang="scss">
@import "./qualityReportUpload.scss";
</style>
